import { RootStore } from './root-store';
import { RootStoreContext } from './root-store/providers';
import { useRootStore } from './root-store/use-root-store';

const { Provider: RootStoreProvider } = RootStoreContext;

export { RootStore, RootStoreProvider, RootStoreContext, useRootStore };
